import React, { Component } from "react";

import Task from "../common/Task";
import SettingsLinks from "./SettingsLinks";
import { connect } from "react-redux";

export default connect()(
  class Settings extends Component {
    render() {
      return (
        <div className="settings-page">
          <p className="title">Settings</p>

          <SettingsLinks />

          <Task
            title="Log out"
            onClick={() => this.props.dispatch({ type: "LOG_OUT" })}
            svg={
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0)">
                  <path
                    d="M12.4999 10.8335C12.0391 10.8335 11.6666 11.2069 11.6666 11.6668V15.0002C11.6666 15.4593 11.2932 15.8334 10.8332 15.8334H8.33319V3.33355C8.33319 2.62189 7.87986 1.98606 7.19826 1.7494L6.95153 1.66685H10.8332C11.2932 1.66685 11.6666 2.041 11.6666 2.50028V5.00026C11.6666 5.46015 12.0391 5.83353 12.4999 5.83353C12.9607 5.83353 13.3331 5.46015 13.3331 5.00026V2.50028C13.3331 1.12197 12.2115 0.000305176 10.8332 0.000305176H1.87498C1.84324 0.000305176 1.81669 0.0144957 1.78587 0.0186155C1.74574 0.0152587 1.70744 0.000305176 1.6667 0.000305176C0.74752 0.000305176 0 0.747673 0 1.66685V16.6667C0 17.3784 0.453334 18.0142 1.13494 18.2509L6.14999 19.9226C6.31997 19.9751 6.48904 20.0001 6.66665 20.0001C7.58583 20.0001 8.33319 19.2526 8.33319 18.3334V17.5001H10.8332C12.2115 17.5001 13.3331 16.3785 13.3331 15.0002V11.6668C13.3331 11.2069 12.9607 10.8335 12.4999 10.8335Z"
                    fill="#2A2B79"
                  />
                  <path
                    d="M19.7555 7.74431L16.4221 4.41106C16.1839 4.17272 15.8255 4.10101 15.5139 4.2301C15.2031 4.35934 14.9997 4.66344 14.9997 5.0002V7.50017H11.6664C11.2064 7.50017 10.833 7.8734 10.833 8.33345C10.833 8.7935 11.2064 9.16672 11.6664 9.16672H14.9997V11.6667C14.9997 12.0035 15.2031 12.3076 15.5139 12.4368C15.8255 12.5659 16.1839 12.4942 16.4221 12.256L19.7555 8.92258C20.0813 8.59681 20.0813 8.07008 19.7555 7.74431Z"
                    fill="#2A2B79"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            }
          />
        </div>
      );
    }
  }
);
